import { Node_Type } from "./../../ricos-types";
import Button from "./button";
const nodeViewRenderers = {
  [Node_Type.BUTTON]: Button
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
